"use client";

import React from "react";
import { WooCommerceCartBlock } from "@/integrations/wordpress/WooCommerceCartBlock";
export default function CartContent() {
  return <section data-section-id="203012" id="cart-content" className="dark bg-background py-16 md:py-24 px-4 sm:px-6 lg:px-8 min-h-[60vh] flex flex-col">
      <div className="max-w-5xl mx-auto w-full flex-1">
        <div className="mb-10 text-center md:text-left">
          <h1 className="text-4xl md:text-5xl font-default font-bold text-foreground mb-4 tracking-tighter">
            Order Summary
          </h1>
          <p className="text-muted-foreground font-sans text-base md:text-lg max-w-2xl">
            Review your digital assets and proceed to secure crypto payment to finalize your access.
          </p>
        </div>
        
        <div className="bg-white/5 backdrop-blur-md rounded-sm shadow-2xl border border-border p-4 sm:p-6 md:p-8">
          <WooCommerceCartBlock />
        </div>
      </div>
    </section>;
}